import { Flex } from "@chakra-ui/react";

type SelectTabProps = {
	value?: string;
	setValue?: (value?: string) => void;
	options: {
		label: string;
		value: string;
	}[];
};

const SelectTab = ({ value, setValue, options }: SelectTabProps) => {
	return (
		<Flex
			backgroundColor="gray.100"
			borderRadius="xl"
			border="solid 1px"
			borderColor="gray.200"
			p="2px"
		>
			{options.map((option) => (
				<Flex
					onClick={() => setValue && setValue(option.value)}
					px="14px"
					alignItems="center"
					fontSize="14px"
					fontWeight="700"
					color="gray.700"
					borderRadius="xl"
					cursor="pointer"
					backgroundColor={value === option.value ? "brand.600" : undefined}
					textColor={value === option.value ? "white" : undefined}
					key={option.value}
				>
					{option.label}
				</Flex>
			))}
		</Flex>
	);
};

export default SelectTab;
